import { render } from "./ActiveUser.vue?vue&type=template&id=19a20804&scoped=true"
import script from "./ActiveUser.vue?vue&type=script&lang=js"
export * from "./ActiveUser.vue?vue&type=script&lang=js"

import "./ActiveUser.vue?vue&type=style&index=0&id=19a20804&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a20804"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QForm,QInput,QBtn});
